import { BlogCardType, HelpCenterListItemType } from '@src/Application/Types/ComponentTypes'

export const mapToBlogCard = (items: HelpCenterListItemType[]): BlogCardType[] =>
    items.map((item) => ({
        image: item.image,
        imageAnimation: item.imageAnimation,
        title: item.title.data?.title,
        category: item.categories[0]?.title,
        link: item.pageUrl,
        date: '',
        description: item.shortDescription,
    }))
